<template>
  <footer class="app-footer">
    <p>&copy; 2023 My App. All rights reserved.</p>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
/* フッターのスタイル */
.app-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  background-color: #f8f8f8;
  min-height: var(--app-footer-height, 48px);
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  text-align: center;
  border-top: 1px solid #dee2e6;
}

.app-footer p {
  margin: 0;
}
</style>
